import React, { Component } from "react"
import * as styles from "./thankyouBountyContest.module.scss"
import ProgressiveImage from "react-progressive-image-loading"
import banner3bg from "../../../../assets/Home-BountyContest.png"
import banner3bgmin from "../../../../assets/Home-BountyContest.png"
import noImage from "../../../../assets/noimage.jpg"

class ThankyouBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
  }

  componentDidMount() {}

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }

  userInfo() {
    if (this.props.logintype === "w") {
      return (
        <React.Fragment>
          {this.props.firstname}{" "}
          {this.props.lastname === "_" ? "" : this.props.lastname}
        </React.Fragment>
      )
    } else {
      return <React.Fragment>{this.props.email}</React.Fragment>
    }
  }

  displaySubmission() {
    if (this.props.submissionTotal > 0) {
      return (
        <div className={styles.contestheading}>
          Last Attempt : {this.props.submissionlastDt}
          <br />
          Total Attempt : {this.props.submissionTotal}
        </div>
      )
    }
  }

  en() {
    return (
      <ProgressiveImage
        preview={banner3bgmin}
        src={banner3bg}
        transitionTime={500}
        transitionFunction="ease"
        render={(src, style) => (
          <div
            className={styles.carouselGraphic3}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
          >
            <div className={styles.carouselText}></div>

            <div className={styles.carouselImg}>
              <div className="row ">
                <div className={styles.contestheading}>
                  <div className={styles.toolHeading}>
                    Welcome to the Contest
                  </div>

                  <div className={styles.userEmail}>
                    {this.userInfo()}
                    <img
                      src={
                        this.props.photo !== null && this.props.photo !== ""
                          ? this.props.photo
                          : noImage
                      }
                      width="20"
                      height="20"
                    />
                  </div>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <button
                    className="btn btn-sm btn-logout from-control"
                    onClick={this.props.handleLogout}
                  >
                    Logout
                  </button>
                </div>
              </div>

              <div className="row top-buffer">{this.displaySubmission()}</div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <div className="btn btn-sm btn-tool from-control ">
                    Submit Answer
                  </div>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  White Paper, Ciphertext, Public Key, Hash value of the
                  original data: &nbsp;
                  <a
                    target="_blank"
                    className="btn btn-sm btn-tool from-control "
                  >
                    Download
                  </a>
                </div>
              </div>

              <div className="row top-buffer toolseparator ">
                <div className="toolsection">
                  <span className="text">Testing Tool</span>
                </div>
              </div>

              <div className="row top-buffer ">
                <div className={styles.contestheading}>
                  {" "}
                  Public Key of the Testing Tool: &nbsp;
                  <a
                    target="_blank"
                    className="btn btn-sm btn-tool from-control"
                  >
                    Download
                  </a>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <div className="input-group">
                    <textarea
                      id="textIn"
                      className="form-control"
                      placeholder="Enter 1 - 128 bytes hex value (e.g. 486c6f23ef....). Note: We will pad your data with 0x00 to the nearest 32 bytes boundary."
                      rows="2"
                      disabled="disabled"
                    />
                    &nbsp;
                    <div className="btn btn-sm btn-tool from-control">
                      Encrypt &gt;&gt;
                    </div>
                  </div>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <div className="input-group">
                    <textarea
                      id="encIn"
                      className="form-control"
                      rows="2"
                      placeholder="Enter 1 - 1024 bytes hex value (e.g. 486c6f23ef....)"
                      disabled="disabled"
                    />
                    &nbsp;
                    <div className="btn btn-sm btn-tool from-control ">
                      {" "}
                      Decrypt &gt;&gt;{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.carouselImgOverlap}>
              <div className={styles.announceHeading}>
                Bounty Contest will begin on
                <br />
                Feb 22, 2021 (EST)
              </div>

              <div className="styles.announceBody">
                All the contest documents, tools, operation buttons will be
                activated on Feb 22, 2021 at 12:00am (EST)
              </div>
            </div>
          </div>
        )}
      />
    )
  }

  ct() {
    return (
      <ProgressiveImage
        preview={banner3bgmin}
        src={banner3bg}
        transitionTime={500}
        transitionFunction="ease"
        render={(src, style) => (
          <div
            className={styles.carouselGraphic3}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
          >
            <div className={styles.carouselText}></div>

            <div className={styles.carouselImg}>
              <div className="row ">
                <div className={styles.contestheading}>
                  <div className={styles.toolHeading}>歡迎參與這場比賽</div>

                  <div className={styles.userEmail}>
                    {this.userInfo()}
                    <img
                      src={
                        this.props.photo !== null && this.props.photo !== ""
                          ? this.props.photo
                          : noImage
                      }
                      width="20"
                      height="20"
                    />
                  </div>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <button
                    className="btn btn-sm btn-logout from-control"
                    onClick={this.props.handleLogout}
                  >
                    登出
                  </button>
                </div>
              </div>

              <div className="row top-buffer">{this.displaySubmission()}</div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <div className="btn btn-sm btn-tool from-control ">
                    提交答案
                  </div>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  IronCAP 技術白皮書, 密文, 公鑰, 原始數據的哈希值: &nbsp;
                  <a
                    target="_blank"
                    className="btn btn-sm btn-tool from-control "
                  >
                    下載
                  </a>
                </div>
              </div>

              <div className="row top-buffer toolseparator ">
                <div className="toolsection">
                  <span className="text">測試工具</span>
                </div>
              </div>

              <div className="row top-buffer ">
                <div className={styles.contestheading}>
                  {" "}
                  測試工具的公鑰: &nbsp;
                  <a
                    target="_blank"
                    className="btn btn-sm btn-tool from-control"
                  >
                    下載
                  </a>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <div className="input-group">
                    <textarea
                      id="textIn"
                      className="form-control"
                      placeholder="輸入1到128個16進制值的字節 (例如: 486c6f23ef...). 注意：我們會將 0x00 填充到最接近的32個字節邊界。"
                      rows="2"
                      disabled="disabled"
                    />
                    &nbsp;
                    <div className="btn btn-sm btn-tool from-control">
                      加密 &gt;&gt;
                    </div>
                  </div>
                </div>
              </div>

              <div className="row top-buffer">
                <div className={styles.contestheading}>
                  <div className="input-group">
                    <textarea
                      id="encIn"
                      className="form-control"
                      rows="2"
                      placeholder="輸入1到1024個16進制值的字節 (例如: 486c6f23ef...)"
                      disabled="disabled"
                    />
                    &nbsp;
                    <div className="btn btn-sm btn-tool from-control ">
                      {" "}
                      解密 &gt;&gt;{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.carouselImgOverlap}>
              <div className={styles.announceHeading}>
                賞金比賽將於
                <br />
                2021年2月22日啟動
              </div>

              <div className="styles.announceBody">
                所有比賽文件，工具，操作按鈕將於2021年2月22日，美國東部標準時間午夜12:00開始生效
              </div>
            </div>
          </div>
        )}
      />
    )
  }
}

export default ThankyouBountyContest
